module.exports = __webpack_public_path__ + "img/minus_w.5b2cbbf9.svg";